module.exports = __webpack_public_path__ + "static/img/torso19.3f898df3.jpg";